module.exports = __webpack_public_path__ + "img/japanese-“reserved”-button.004d7096.png";